const STORAGE_KEY = 'wiki_favorites_slugs';

export function getWikiFavorites() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    const arr = raw ? JSON.parse(raw) : [];
    return Array.isArray(arr) ? arr.filter((s) => typeof s === 'string' && s.trim()) : [];
  } catch (_) {
    return [];
  }
}

export function addWikiFavorite(slug) {
  const slugStr = String(slug || '').trim();
  if (!slugStr) return;
  const list = getWikiFavorites();
  if (list.includes(slugStr)) return;
  localStorage.setItem(STORAGE_KEY, JSON.stringify([...list, slugStr]));
}

export function removeWikiFavorite(slug) {
  const slugStr = String(slug || '').trim();
  const list = getWikiFavorites().filter((s) => s !== slugStr);
  localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
}

export function toggleWikiFavorite(slug) {
  const list = getWikiFavorites();
  if (list.includes(String(slug || '').trim())) {
    removeWikiFavorite(slug);
    return false;
  }
  addWikiFavorite(slug);
  return true;
}

export function isWikiFavorite(slug) {
  return getWikiFavorites().includes(String(slug || '').trim());
}
